import React, { Component } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Asset from './Asset';

import { AssetProps } from './Helpers';

export default class ProductCategoryCard extends Component {
  static renderImage(image, link) {
    const {
      horizontalAlign,
      textColor,
      destinationPage,
      text,
      className,
      callToAction,
    } = link;

    return (
      <div className="product-category-card__item"
        data-testid="product-category-card__item"
      >
        <div className="product-category-card__image">
          <Link
            className={`${className} ${textColor ? textColor.toLowerCase() : 'white'}`}
            to={destinationPage.url}
          >
            <Asset
              asset={image}
              imageProps={{
                blurryPlaceholder: false,
              }}
            />
          </Link>
        </div>
        <div className={`product-category-card__item-copy ${horizontalAlign ? horizontalAlign.toLowerCase() : ''}`}>
          <Link
            className={`${className} ${textColor ? textColor.toLowerCase() : 'white'}`}
            to={destinationPage.url}
          >
            {text}
          </Link>
        </div>
        {callToAction && callToAction.badgeCopy && (
          <div
            className={classNames(
              'product-category-card__item-badge',
              callToAction.backgroundColor && `product-category-card__item-badge--${callToAction.backgroundColor.toLowerCase()}-background`,
              callToAction.textColor && `product-category-card__item-badge--${callToAction.textColor.toLowerCase()}-text`,
            )}
          >
            {callToAction.badgeCopy}
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      anchor,
      header,
      images,
      className,
      links,
      align,
    } = this.props;

    return (
      <section id={anchor || undefined} className="product-category-card">
        {header && (
          <h2
            className={`product-category-card__title h2${align ? ` ${align.toLowerCase()}` : ''}`}
          >
            {header}
          </h2>
        )}

        {images && images.length > 2 && links && links.length > 2 && (
          <div className={`product-category-card__items product-category-card__items--${className}`}>
            {ProductCategoryCard.renderImage(images[0], links[0])}
            {ProductCategoryCard.renderImage(images[1], links[1])}
            {ProductCategoryCard.renderImage(images[2], links[2])}
          </div>
        )}
      </section>
    );
  }
}

ProductCategoryCard.defaultProps = {
  className: 'left-expanded',
};

ProductCategoryCard.propTypes = {
  className: PropTypes.oneOf([
    'top-expanded',
    'right-expanded',
    'bottom-expanded',
    'left-expanded',
  ]),
  header: PropTypes.string,
  images: PropTypes.arrayOf(AssetProps),
  links: PropTypes.array,
  align: PropTypes.string,
};
